import DevicesIcon from '@/assets/devices.svg';
import GroupsIcon from '@/assets/groups.svg';
import PoliciesIcon from '@/assets/policies.svg';
import UnitsIcon from '@/assets/units.svg';
import UsersIcon from '@/assets/users.svg';
import { strings } from '@/constants/strings';
import { urls } from '@/constants/urls';
import { NavItem } from '@/types/nav-item';

export const organisationNavItems: NavItem[] = [
  {
    title: 'Groups',
    to: urls.groups.base,
    Icon: GroupsIcon,
    tooltip: strings.sidebar.groups.tooltip,
  },
  {
    title: 'Units',
    to: urls.units.base,
    Icon: UnitsIcon,
    tooltip: strings.sidebar.units.tooltip,
  },
  {
    title: 'Devices',
    to: urls.devices.base,
    Icon: DevicesIcon,
    tooltip: strings.sidebar.devices.tooltip,
  },
  {
    title: 'Policies',
    to: urls.policies.base,
    Icon: PoliciesIcon,
    tooltip: strings.sidebar.policies.tooltip,
  },
  {
    title: 'Users',
    to: urls.users.base,
    Icon: UsersIcon,
    tooltip: strings.sidebar.users.tooltip,
  },
  {
    title: 'Dashboard',
    to: urls.reporting.base,
    Icon: GroupsIcon,
    tooltip: strings.sidebar.dashboard.tooltip,
  },
];
